import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { FormattedMessage } from 'react-intl';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography
} from '@material-ui/core';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import { ProjectTeamMemberAssignmentType } from '~/types';
import EditProjectDialogActions from '~/modules/projects/project/ProjectInfoDetails/EditProjectDialog/EditProjectDialogActions';
import EditProjectSettingsForm from './EditProjectSettingsForm';
import { useUpdateProjectSettings } from './useUpdateProjectSettings';

const dialogTransitionProps = { role: 'presentation' };

export const EditProjectSettingsDialog = ({
  open,
  onClose,
  projectId,
  projectTeamMemberAssignmentType
}) => {
  const isMobile = useIsBreakpointDown('sm');

  const initialValues = useMemo(
    () => ({
      projectUri: projectId,
      projectTeamMemberAssignmentType:
        projectTeamMemberAssignmentType ||
        ProjectTeamMemberAssignmentType.ManuallyAssignTask
    }),
    [projectId, projectTeamMemberAssignmentType]
  );

  const onSubmit = useUpdateProjectSettings({ closeDialog: onClose });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
        disableEscapeKeyDown
        TransitionProps={dialogTransitionProps}
      >
        <DialogTitle disableTypography>
          <Typography variant="h6">
            <FormattedMessage id="projectSettingsCard.projectSettings" />
          </Typography>
        </DialogTitle>
        <DialogContent>
          <EditProjectSettingsForm />
        </DialogContent>
        <EditProjectDialogActions onClose={onClose} />
      </Dialog>
    </Formik>
  );
};

EditProjectSettingsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  projectId: PropTypes.string,
  projectTeamMemberAssignmentType: PropTypes.string
};

export default EditProjectSettingsDialog;
